import Bundles from "./Bundles";

export default Bundles;
